import { render, staticRenderFns } from "./ApplicantOrigins.vue?vue&type=template&id=36893c88&"
import script from "./ApplicantOrigins.vue?vue&type=script&lang=js&"
export * from "./ApplicantOrigins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports